module.exports = __webpack_public_path__ + "static/media/successDot.25639824.svg";